module.exports = __webpack_public_path__ + "img/mobile-instructions.99437736.png";